import './FoundingClinic.css';
import goldIcon from '../assets/gold-icon.png';
import foundingBg from '../assets/founding-bg.jpg';
import { useScrollReveal } from '../hooks/useScrollReveal';

function FoundingClinic() {
    const [ref, visible] = useScrollReveal(0.15);
    return (
        <section ref={ref} className={`founding-clinic ${visible ? 'visible' : ''}`} style={{ backgroundImage: `url(${foundingBg})` }}>
            <div className="founding-clinic-card">
                <span className="founding-clinic-badge">Limited offer</span>
                <h2>Founding Clinic Program</h2>
                <p className="founding-clinic-subtitle">
                    Be one of the first 10 clinics on Lemadoo and lock in a special rate forever.
                </p>

                <div className="founding-clinic-pricing">
                    <div className="founding-clinic-plan">
                        <img src={goldIcon} alt="Gold" className="founding-clinic-icon" />
                        <span className="founding-clinic-plan-name">Gold</span>
                    </div>
                    <div className="founding-clinic-prices">
                        <span className="founding-clinic-original">Rp 350.000</span>
                        <span className="founding-clinic-discounted">Rp 200.000<span className="founding-clinic-period">/mo</span></span>
                    </div>
                </div>

                <ul className="founding-clinic-perks">
                    <li><i className="fas fa-star"></i> Only for the first 10 clinics registered</li>
                    <li><i className="fas fa-lock"></i> Price locked forever, even if Gold pricing changes</li>
                </ul>

                <a
                    href="https://wa.me/6287883393211?text=Hi%2C%20I'm%20interested%20in%20the%20Founding%20Clinic%20Program!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="founding-clinic-btn"
                >
                    <i className="fab fa-whatsapp"></i> Contact us on WhatsApp
                </a>
            </div>
        </section>
    );
}

export default FoundingClinic;
